module.exports = __webpack_public_path__ + "static/media/Slide4-web.47b602f3.jpg";